module.exports = __webpack_public_path__ + "static/becoming-christmas-karen-bbb3a94ddd5f406c1b12f0368b33e621.jpg";